import { render, staticRenderFns } from "./archivesList.vue?vue&type=template&id=27ce4de9&scoped=true"
import script from "./archivesList.vue?vue&type=script&lang=js"
export * from "./archivesList.vue?vue&type=script&lang=js"
import style0 from "./archivesList.vue?vue&type=style&index=0&id=27ce4de9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ce4de9",
  null
  
)

export default component.exports